import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Layout from '@components/layout';
import SEO from '@components/seo';
import moduleHeroConductor from '@modules/hero-module/module-hero-conductor';
import moduleConductor from '@modules/module-conductor';

export const pageQuery = graphql`
  {
    pageData: contentfulTemplatePage(contentful_id: { eq: "32xEMswEmCLSJl9A9iFXyK" }) {
      id
      contentful_id
      slug
      url
      seo {
        ...GlobalSEOFragment
      }
      hero {
        ...ModuleHeroFragment
      }
      sections {
        ...ModuleHeaderFragment
        ...ModuleServiceListFragment
        ...ModuleGlobalItemFragment
      }
      footer
    }
    services: allContentfulItemServices(
      filter: { serviceType: { ne: null } }
      sort: { fields: updatedAt, order: DESC }
    ) {
      nodes {
        ...GlobalServicesFragment
      }
    }
    breadcrumbList: allContentfulSeo(
      filter: { pageUrl: { regex: "^?:/(what-we-do/$)|(what-we-do/how-we-can-help/$)/" } }
    ) {
      nodes {
        pageUrl
        pageTitle
      }
    }
  }
`;

const HowWeCanHelp = ({ location, data }) => {
  const {
    pageData: { seo, hero, footer, sections },
    breadcrumbList,
  } = data;

  const breadcrumbs = breadcrumbList && breadcrumbList.nodes;
  const heroSection = hero && moduleHeroConductor(hero, hero.type, { opacity: 0.8, dot: true });
  let modules = sections &&
    sections.map((module, index) => moduleConductor(module, index, { padding: 'ph30_medium' }));

  return (
    <Layout location={location} footer={footer}>
      {seo && <SEO data={seo} location={location} breadcrumbs={breadcrumbs} />}
      {heroSection}
      {modules}
    </Layout>
  );
};

HowWeCanHelp.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export default HowWeCanHelp;
